import React from "react";

import { CollapseHeader, FormCollapse } from "components/Form";
import { FinanceSubModalSection } from "constants/settings";
import { useSectionHelper, SectionToggleState } from "hooks";

import { Grid } from "@material-ui/core";

import { Label } from "components/Form/FormikControls";
import { SplitAllocationForm } from "components/TransactionSplits/SplitAllocationForm";
import { SplitOrigin } from "constants/splits";

interface SectionProps {
  sectionHelper: SectionToggleState;
}

export const BusinessBuyerSplitsSection: React.FC<SectionProps> = ({
  sectionHelper,
}) => {
  const { isOpen, onToggle } = useSectionHelper(
    sectionHelper,
    FinanceSubModalSection.BUYER_SPLITS,
  );

  const header = <CollapseHeader title="Buyer Splits" />;

  return (
    <FormCollapse
      isOpen={isOpen}
      onToggle={onToggle}
      header={header}
      dataTour="buyerSplitsCollapse"
    >
      <Grid data-tour="defaultBuyerSplits" container spacing={2} item xs={12}>
        <Grid item xs={12}>
          <Label>Default Buyer Splits</Label>
        </Grid>
        <SplitAllocationForm
          namespace="defaultBuyerSplit"
          splitType={SplitOrigin.BUYER}
        />
      </Grid>
    </FormCollapse>
  );
};
